export default __webpack_public_path__ + "static/media/1213 utensils top.1276ea8d.png";